import { render, staticRenderFns } from "./post_row.vue?vue&type=template&id=7b41f583&scoped=true"
import script from "./post_row.vue?vue&type=script&lang=js"
export * from "./post_row.vue?vue&type=script&lang=js"
import style0 from "./post_row.vue?vue&type=style&index=0&id=7b41f583&prod&lang=css"
import style1 from "./post_row.vue?vue&type=style&index=1&id=7b41f583&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b41f583",
  null
  
)

export default component.exports